import { createStyles, makeStyles } from "@material-ui/styles";
import { RelodeTheme, WizardProvider, WizardStep } from "@relode/core";
import * as React from "react";

import { useAddJobContext } from "../_infra";
import { AddJobStepsEnum } from "../types";
import { AddJobProps } from "./addJobProps";
import { Step1, Step2, Step3 } from "./steps";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            wizardContentAreaWrapper: {
                marginTop: theme.spacing(3),
                display: "flex",
                justifyContent: "center",
                flex: 1,
            },
            wizardContentArea: {
                display: "flex",
                flexBasis: "50%",
                flexDirection: "column",
                flexGrow: 1,
            },
        }),
    { name: "AddJobDesktop" }
);

export const AddJobDesktop = (props: AddJobProps) => {
    const classes = useStyles({});
    const {
        handleClose,
        handleNext,
        handlePrevious,
        handleSaveAndExit,
        activeStepId,
        handleFieldChange,
        handleButtonFieldChange,
    } = props;

    const {
        state: {
            ui: { isLoading, showOrderConfirmationStep },
        },
        formikProps,
    } = useAddJobContext();
    const { isValid, errors } = formikProps;

    return (
        <WizardProvider
            id="addJobWizard"
            onCancel={handleClose}
            onFinish={() => handleNext()}
            title="add job"
            hasError={!isValid}
            onNext={handleNext}
            onPrevious={handlePrevious}
            onSaveAndExit={handleSaveAndExit}
            activeStepId={activeStepId}
            isLoading={isLoading}
            loadingDisplayText={undefined}
            presenter={p => (
                <div className={classes.wizardContentAreaWrapper} key="content">
                    <div className={classes.wizardContentArea}>
                        {p.children}
                    </div>
                </div>
            )}
        >
            <WizardStep
                id={AddJobStepsEnum.Step1}
                component={<Step1 handleFieldChange={handleFieldChange} />}
                title="job description"
                hasError={!!errors.stepOne}
            />
            <WizardStep
                id={AddJobStepsEnum.Step2}
                component={
                    <Step2
                        handleFieldChange={handleFieldChange}
                        handleButtonFieldChange={handleButtonFieldChange}
                    />
                }
                title="job details"
                hasError={!!errors.stepTwo}
            />
            {showOrderConfirmationStep ? (
                <WizardStep
                    id={AddJobStepsEnum.Step3}
                    component={<Step3 />}
                    title="order confirmation"
                />
            ) : null}
        </WizardProvider>
    );
};
